<nav class="site-nav glass-nav w-full" [class.site-nav--minimal]="minimal">
  <div class="site-nav-inner flex w-full items-center justify-between gap-6 px-4 sm:px-6 md:px-10 lg:px-12">
    <a [href]="logoHref" class="site-nav-logo flex shrink-0 items-center" (click)="closeMobile()">
      <img
        src="assets/brand/sahkaarx-logo.png"
        alt="SahkaarX"
        class="h-8 md:h-9 w-auto object-contain"
        onerror="this.src='https://sahkaarx.com/assets/images/sahkaarx-logo.png'"
      />
    </a>

    @if (showPublicLinks) {
      <div class="site-nav-links hidden items-center md:flex">
        <a class="site-nav-link" [href]="marketingSiteUrl">Home</a>
        <a class="site-nav-link" [href]="marketingSiteUrl + '/#pathfinding'">Path to Placement</a>
        <a class="site-nav-link" [href]="marketingSiteUrl + '/#why-sahkaarx'">Why SahkaarX</a>
        <a class="site-nav-link" [href]="marketingSiteUrl + '/career-challenges'">Career Challenges</a>
        <a class="site-nav-link" [href]="marketingSiteUrl + '/about-us'">About Us</a>
      </div>
    }

    @if (hasRightActions) {
      <div class="site-nav-actions hidden items-center md:flex">
        @if (isAuthenticatedLearner) {
          <div class="site-nav-learner">
            <a class="site-nav-link" [href]="marketingSiteUrl">Home</a>
            <div class="site-nav-learner-primary">
              <a
                routerLink="/learning"
                routerLinkActive="is-active"
                class="site-nav-link"
              >My Learning</a>
              <a
                [class.is-active]="isRouteActive('/career-challenges')"
                class="site-nav-link"
                (click)="careerChallengesLink()"
              >Career Challenges</a>
              <a routerLink="/journey" routerLinkActive="is-active" class="site-nav-link">My Journey</a>
              <a routerLink="/community" routerLinkActive="is-active" class="site-nav-link">Community</a>
            </div>

            <div class="site-nav-notifications">
              <button
                type="button"
                class="site-nav-notifications-trigger"
                [class.is-active]="notificationsActive || notificationsMenuOpen()"
                (click)="toggleNotificationsMenu()"
                [attr.aria-expanded]="notificationsMenuOpen()"
                aria-haspopup="menu"
                aria-label="Open notifications"
              >
                <span class="material-symbols-outlined">notifications</span>
                @if (badgeLabel) {
                  <span class="site-nav-notifications-badge">{{ badgeLabel }}</span>
                }
              </button>

              @if (notificationsMenuOpen()) {
                <div class="site-nav-notifications-dropdown" role="menu">
                  <div class="site-nav-notifications-head">
                    <h2 class="site-nav-notifications-title">Notifications</h2>
                    <a routerLink="/notifications" routerLinkActive="is-active" (click)="closeNotificationsMenu()">View all</a>
                  </div>

                  @if (notificationsLoading) {
                    <div class="site-nav-notifications-empty flex items-center justify-center gap-2 py-8 text-xs text-slate-500 font-medium">
                      <span class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-slate-300 border-t-[#0a361e]"></span>
                      <span>Loading notifications...</span>
                    </div>
                  } @else if (!recentNotifications.length) {
                    <div class="site-nav-notifications-empty py-8 text-center text-xs text-slate-500 font-medium">
                      <p class="text-slate-800 font-bold text-sm mb-1">You are all caught up</p>
                      <p>No notifications right now.</p>
                    </div>
                  } @else {
                    <div class="site-nav-notifications-list">
                      @for (item of recentNotifications; track item.id) {
                        <button
                          type="button"
                          class="site-nav-notifications-card"
                          role="menuitem"
                          (click)="openNotification(item)"
                        >
                          <span
                            class="notification-status-dot"
                            [class.notification-status-dot--unread]="!item.isRead"
                            [class.notification-status-dot--read]="item.isRead"
                          ></span>

                          <div class="notification-card-content">
                            <div class="notification-card-top">
                              <span class="notification-card-title">{{ item.title }}</span>
                              <div class="notification-card-meta">
                                @if (isActionRequired(item)) {
                                  <span class="notification-action-tag">ACTION</span>
                                }
                                <span class="notification-card-time">{{ formatTimeAgo(item.createdAt) }}</span>
                              </div>
                            </div>

                            @if (item.body) {
                              <p class="notification-card-body">{{ item.body }}</p>
                            }
                          </div>
                        </button>
                      }
                    </div>
                  }
                </div>
              }
            </div>

            <div class="site-nav-account">
              <button
                type="button"
                class="site-nav-account-trigger"
                [class.is-active]="accountActive"
                (click)="toggleAccountMenu()"
                [attr.aria-expanded]="accountMenuOpen()"
                aria-haspopup="menu"
                aria-label="Open account menu"
              >
                <span class="material-symbols-outlined">person</span>
                <span>Account</span>
                <span class="material-symbols-outlined site-nav-account-chevron">
                  {{ accountMenuOpen() ? 'expand_less' : 'expand_more' }}
                </span>
              </button>

              @if (accountMenuOpen()) {
                <div class="site-nav-account-dropdown" role="menu" (click)="$event.stopPropagation()">
                  <a routerLink="/account/profile" class="site-nav-account-item" routerLinkActive="is-active" role="menuitem" (click)="openAccountProfile($event)">My Account</a>
                  <a routerLink="/account/learning-plans" class="site-nav-account-item" role="menuitem" routerLinkActive="is-active" (click)="closeAccountMenu()">My Learning Plans</a>
                  <a routerLink="/account/challenges" class="site-nav-account-item" role="menuitem" routerLinkActive="is-active" (click)="closeAccountMenu()">My Code Challenges</a>
                  <a routerLink="/achievements" class="site-nav-account-item" role="menuitem" routerLinkActive="is-active" (click)="closeAccountMenu()">Achievements & Sharing</a>
                  <a routerLink="/job-readiness" class="site-nav-account-item" role="menuitem" routerLinkActive="is-active" (click)="closeAccountMenu()">Job Readiness</a>
                  <a routerLink="/account/shares" class="site-nav-account-item" role="menuitem" routerLinkActive="is-active" (click)="closeAccountMenu()">My Shared Links</a>
                  <a routerLink="/account/skills" class="site-nav-account-item" role="menuitem" routerLinkActive="is-active" (click)="closeAccountMenu()">My Skills</a>
                  <button type="button" class="site-nav-account-item" role="menuitem" (click)="signOut()">
                    Sign out
                  </button>
                </div>
              }
            </div>
          </div>
        } @else if (isAuthenticatedPortal) {
          <div class="site-nav-learner">
            <div class="site-nav-learner-primary">
              <a routerLink="/portal" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }" class="site-nav-link">Hub</a>
              @if (portalPartnerEnabled) {
                <a routerLink="/portal/partner" routerLinkActive="is-active" class="site-nav-link">Partner</a>
              }
              @if (portalReferralEnabled) {
                <a routerLink="/portal/referral" routerLinkActive="is-active" class="site-nav-link">Referral</a>
              }
            </div>
            <div class="site-nav-account">
              <button
                type="button"
                class="site-nav-account-trigger"
                (click)="toggleAccountMenu()"
                [attr.aria-expanded]="accountMenuOpen()"
                aria-haspopup="menu"
                aria-label="Open account menu"
              >
                <span class="material-symbols-outlined">person</span>
                <span>{{ portalAccountName || 'Partner' }}</span>
                <span class="material-symbols-outlined site-nav-account-chevron">
                  {{ accountMenuOpen() ? 'expand_less' : 'expand_more' }}
                </span>
              </button>
              @if (accountMenuOpen()) {
                <div class="site-nav-account-dropdown" role="menu" (click)="$event.stopPropagation()">
                  <button type="button" class="site-nav-account-item" role="menuitem" (click)="signOut()">
                    Sign out
                  </button>
                </div>
              }
            </div>
          </div>
        } @else if (showSignInCta) {
          <a routerLink="/learner/login" class="sx-btn-primary">Sign in</a>
        } @else if (variant === 'marketing' && !minimal) {
          <a [href]="ctaUrl" target="_blank" rel="noreferrer" class="sx-btn-primary">Start Free Analysis</a>
        }
      </div>
    }

    <button
      type="button"
      class="site-nav-menu-btn flex h-10 w-10 items-center justify-center rounded-lg border border-outline-variant md:hidden"
      (click)="toggleMobile()"
      aria-label="Toggle menu"
    >
      <span class="material-symbols-outlined text-on-surface">{{ mobileOpen() ? 'close' : 'menu' }}</span>
    </button>
  </div>

  @if (mobileOpen()) {
    <div class="site-nav-mobile border-t border-outline-variant bg-surface-container-lowest px-gutter py-4 md:hidden">
      <div class="flex flex-col gap-3">
        @if (isAuthenticatedLearner) {
          <div class="site-nav-mobile-group">
            <a class="site-nav-link" [href]="marketingSiteUrl" (click)="closeMobile()">Home</a>
            <a
              routerLink="/learning"
              routerLinkActive="is-active"
              class="site-nav-link"
              (click)="closeMobile()"
            >My Learning</a>
            <a
              [class.is-active]="isRouteActive('/career-challenges')"
              class="site-nav-link"
              (click)="careerChallengesLink(); closeMobile()"
            >Career Challenges</a>
            <a routerLink="/journey" routerLinkActive="is-active" class="site-nav-link" (click)="closeMobile()">My Journey</a>
            <a routerLink="/community" routerLinkActive="is-active" class="site-nav-link" (click)="closeMobile()">Community</a>
            <a
              routerLink="/notifications"
              routerLinkActive="is-active"
              class="site-nav-link"
              (click)="closeMobile()"
            >Notifications @if (badgeLabel) { ({{ badgeLabel }}) }</a>
          </div>
          <div class="site-nav-mobile-group site-nav-mobile-group--secondary">
            <span class="site-nav-mobile-label">Account</span>
            <a
              routerLink="/account/profile"
              routerLinkActive="is-active"
              class="site-nav-link"
              (click)="closeMobile()"
            >My Account</a>
            <a routerLink="/account/learning-plans" routerLinkActive="is-active" class="site-nav-link" (click)="closeMobile()">My Learning Plans</a>
            <a routerLink="/account/challenges" routerLinkActive="is-active" class="site-nav-link" (click)="closeMobile()">My Code Challenges</a>
            <a routerLink="/achievements" routerLinkActive="is-active" class="site-nav-link" (click)="closeMobile()">Achievements & Sharing</a>
            <a routerLink="/job-readiness" routerLinkActive="is-active" class="site-nav-link" (click)="closeMobile()">Job Readiness</a>
            <a routerLink="/account/shares" routerLinkActive="is-active" class="site-nav-link" (click)="closeMobile()">My Shared Links</a>
            <a routerLink="/account/skills" routerLinkActive="is-active" class="site-nav-link" (click)="closeMobile()">My Skills</a>
            <button type="button" class="site-nav-link" (click)="signOut()">Sign out</button>
          </div>
        } @else if (isAuthenticatedPortal) {
          <div class="site-nav-mobile-group">
            <a routerLink="/portal" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }" class="site-nav-link" (click)="closeMobile()">Hub</a>
            @if (portalPartnerEnabled) {
              <a routerLink="/portal/partner" routerLinkActive="is-active" class="site-nav-link" (click)="closeMobile()">Partner</a>
            }
            @if (portalReferralEnabled) {
              <a routerLink="/portal/referral" routerLinkActive="is-active" class="site-nav-link" (click)="closeMobile()">Referral</a>
            }
            <button type="button" class="site-nav-link" (click)="signOut()">Sign out</button>
          </div>
        } @else if (showPublicLinks) {
          <div class="site-nav-mobile-group">
            <a class="site-nav-link" [href]="marketingSiteUrl" (click)="closeMobile()">Home</a>
            <a class="site-nav-link" [href]="marketingSiteUrl + '/#pathfinding'" (click)="closeMobile()">Path to Placement</a>
            <a class="site-nav-link" [href]="marketingSiteUrl + '/#why-sahkaarx'" (click)="closeMobile()">Why SahkaarX</a>
            <a class="site-nav-link" [href]="marketingSiteUrl + '/career-challenges'" (click)="closeMobile()">Career Challenges</a>
            <a class="site-nav-link" [href]="marketingSiteUrl + '/about-us'" (click)="closeMobile()">About Us</a>
          </div>
          @if (showSignInCta) {
            <a routerLink="/learner/login" class="sx-btn-primary text-center" (click)="closeMobile()">Sign in</a>
          } @else if (variant === 'marketing') {
            <a [href]="ctaUrl" target="_blank" rel="noreferrer" class="sx-btn-primary text-center" (click)="closeMobile()">Start Free Analysis</a>
          }
        }
      </div>
    </div>
  }
</nav>

@if (showEmailVerificationBanner) {
  <div class="w-full border-b border-amber-200 bg-amber-50 px-4 py-2 text-center text-xs font-medium text-amber-900 sm:px-6 md:px-10 lg:px-12">
    Verify your email to receive challenge deadlines and results.
    <a routerLink="/account" class="ml-1 font-bold underline underline-offset-2">Verify now</a>
  </div>
}
